// extracted by mini-css-extract-plugin
module.exports = {"mobileMaxHeight":"152px","desktopMaxHeight":"112px","root":"rWBXWg","list":"SL-0DZ","listWrapper":"c7Ifi9r","expanded":"Si-vZW","seeMore":"EgjLJi"};